import { Group, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { Department } from './../../model/DepartmentTypes';
import classes from './DepartmentCard.module.css';

export interface DepartmentCardProps {
  department: Department;
  to: string;
}

export function DepartmentCard({ department, to }: DepartmentCardProps) {
  const { name, faculty } = department;

  return (
    <Paper
      className={classes.card}
      component={Link}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="12px">
        <TitleCard title={name} />

        <Group>
          <Text
            c="dimmed"
            size="sm"
          >
            {faculty.name}
          </Text>
        </Group>
      </Stack>
    </Paper>
  );
}
